import { Typography } from '@mui/material';

type ModalTitleProps = {
  title?: string;
};

export const ModalTitle = ({ title }: ModalTitleProps) =>
  title && (
    <Typography
      variant="h4"
      className="flex flex-col width-100 mb1 title-container"
      data-cy="modal-title"
    >
      {title}
    </Typography>
  );
